import {
    Backdrop,
    Box,
    Button,
    CircularProgress,
    useTheme,
  } from "@mui/material";
  import React, { useEffect, useRef, useState } from "react";
  import { useDispatch, useSelector } from "react-redux";
  import {
    checkGuestLimit,
    setDateLoading,
    setIsOpenWidget,
    setLanguageID,
    setLanguageWords,
    setReservationGroupDatas,
    setReservationTypeDatas,
    updateDefaultLanguage,
    updateReservationGroup,
    updateTotalCount,
  } from "../store/slice/Addguest.slice";
  import { useLocation, useNavigate, useParams } from "react-router-dom";
  
  import {
    FetchWidgetConfigDetails,
    GetGuestDetailsByKey,
    getCalenderDatas,
    getLanguageDetails,
    getReservationGroup,
    getReservationType,
    getReservationTypeBasedOnProducts,
    getWidgetSettings,
    getWidgetTitleandInfo,
  } from "../api/HorecaWidget.service";
  import {
    setLanguageLoaded,
    updateBlockedDates,
    updateButtonText,
    updateGuestInfo,
    updateLanguageData,
    updateWidgetConfig,
    updateWidgetSetting,
  } from "../store/slice/widgetSetting.slice";
  import customParseFormat from "dayjs/plugin/customParseFormat";
  import dayjs from "dayjs";
//   import { setCombinationList } from "../../store/slice/Activity.slice";
//   import { getCombinationList } from "../../api/activity.service";
import { getCombinationList } from "../api/activity.service"
import { setCombinationList } from "../store/slice/Activity.slice";
  dayjs?.extend(customParseFormat); // Extend for custom date format parsing
  
  let loadSettings = null;
  let widgetIdSettings = null;

const useHorecaWidget = () => {
  
    const [widgetLoading, setWidgetLoading] = useState(false);
    const[combinationLoading,setCombinationLoading]=useState(false)
    const [langLoading, setLangLoading] = useState(false);
    const theme = useTheme();
    const {
      totalCount,
      selectedDate,
      reservType,
      time,
      adult,
      child,
      kid,
      baby,
      toddler,
      reservationGroupData,
      isBackToHoreca,
      defaultLanguage,
      isOpenWidget,
    } = useSelector((store) => store.addGuest);
    const {
      WidgetSetting,
      key,
      widgetConfig,
      languageLoaded,
      guestId,
      resType,
      widgetSetupId,
      buttonText,
    } = useSelector((store) => store?.widgetSettings);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const dispatch = useDispatch();
    const [reservTypeLoading, setReserveTypeLoading] = useState(false);
    const [reservationRequestMin, setResReqMin] = useState(0);
    const [isAddGuest, setIsAddGuest] = useState(false);
    const [openWidget, setOpenWidget] = useState(
      location?.state?.openWidgetScreen ?? isOpenWidget
    );
    const getWidgetPositionStyle = (position, btn) => {
    switch (position) {
      case "Top":
        return { top: "0", left: "0", transform: "translate(0, 0)" };
      case "Top-Left":
        return { top: "20px", left: "0px", transform: "translate(0, 0)" };
      case "Top-Middle":
        return { top: "0", left: "50%", transform: "translateX(-50%)" };
      case "Top-Right":
        return { top: "0", right: "20px", transform: "translate(0, 0)" };
      case "Middle-Left":
        return { top: "50%", left: "0px", transform: "translateY(-50%)" };
      case "Middle-Center":
        return { top: "50%", left: "50%", transform: "translate(-50%, -50%)" };
      case "Middle-Right":
        return { top: "50%", right: "20px", transform: "translateY(-50%)" };
      case "Bottom-Left":
        return { bottom: "20px", left: "0px", transform: "translate(0, 0)" };
      case "Bottom-Middle":
        return { bottom: "20px", left: "50%", transform: "translateX(-50%)" };
      case "Bottom-Right":
        return { bottom: "0", right: "0", transform: "translate(0, 0)" };
      default:
        if (btn) {
          return { bottom: "0", right: "0", transform: "translate(0, 0)" };
        } else {
          return {
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          };
        }
    }
  };
    const fetchLanguageDetails = async () => {
      setLangLoading(true);
      try {
        const response = await getLanguageDetails(key);
       
        if (response?.status != 200) {
          console.error("Error fetching language details widget:", response);
          return;
        }
        if(response?.data?.length == 0){
          console.error("No language data found for the widget.");
          dispatch(updateDefaultLanguage('EN'));
          return;
        }
        dispatch(updateLanguageData(response?.data));
        const langParam = queryParams.get("lang");
        if (response?.data) {
       
          const defaultLang =
            !defaultLanguage && !langParam
              ? response?.data?.find((item) => item?.defaultLanguage)?.langcode
              : langParam
              ? langParam
              : defaultLanguage;
              localStorage.setItem(
                "widget",
                JSON.stringify({
                  id: widgetSetupId,
                  key: key,
                  lang: defaultLang,
                  resType:resType
                })
              );
  
          dispatch(updateDefaultLanguage(defaultLang));
          dispatch(setLanguageLoaded(true)); // Set the flag to true
          dispatch(setLanguageID(defaultLang?.idlanguage));
        }
        setLangLoading(false);
      } catch (error) {
        console.error("Error fetching language details widget:", error?.message);
        setLangLoading(false);
      }
    };
    const fetchWidgetSettings = async (language) => {
      try {
        const response = await getWidgetSettings(language, key);
        if (response?.status !== 200 || !response?.data) {
          throw new Error(
            "Failed to fetch widget settings. Please try again later."
          );
        }
        loadSettings = response?.data;
        dispatch(updateWidgetSetting(response?.data));
      } catch (error) {
        const errorMsg =
          error?.message ||
          "An unexpected error occurred while fetching widget settings.";
        console.error("Error fetching widget settings:", errorMsg);
      }
    };
    const fetchWidgetTitleandInfo = async (widgetSetupId, language) => {
      try {
        const response = await getWidgetTitleandInfo(widgetSetupId, language);
        if (response?.status != 200 || !response?.data) {
          throw new Error(
            "Failed to fetch widget title and info. Please try again later."
          );
        }
        widgetIdSettings = response?.data;
      } catch (error) {
        console.error("Error fetching widget settings:", error?.message);
      }
    };
  
    const getUnavailableCalenderDetails = async () => {
      dispatch(setDateLoading(true));
      try {
        const response = await getCalenderDatas(
          key,
          totalCount,
          widgetSetupId,
          reservationRequestMin
        );
        if (response?.status != 200 || !response?.data) {
          throw new Error(
            "Failed to fetch unavailable dates. Please try again later."
          );
        }
        dispatch(updateBlockedDates(response?.data));
        dispatch(setDateLoading(false));
        return response;
      } catch (error) {
        console.error("Error fetching unavailable dates", error);
        dispatch(setDateLoading(false));
      }
    };
  
    const fetchReservationType = async () => {
      setReserveTypeLoading(true); // Start loading
      const parsedDate = dayjs(selectedDate, "DD-MM-YYYY", true);
      // Check if date is valid
      if (!parsedDate.isValid()) {
        setReserveTypeLoading(false); // Stop loading on error
        return;
      }
      // Format the valid date into 'YYYY-MM-DD'
      const formattedDate = parsedDate.format("YYYY-MM-DD");
      const payload = {
        idwidgetsetup: parseInt(widgetSetupId),
        amount: parseInt(totalCount),
        date: formattedDate,
        key: key,
        field2: false,
        field1GuestCount: parseInt(adult),
        field2GuestCount: parseInt(child),
        field3GuestCount: parseInt(kid),
        field4GuestCount: parseInt(baby),
        field5GuestCount: parseInt(toddler),
        reservationRequestMin: parseInt(reservationRequestMin),
        lang: defaultLanguage,
      };
      try {
        const response = await getReservationType(payload);
        if (response.status != 200 || !response?.data || response.length === 0) {
          throw new Error(
            "Failed to fetch reservation types. Please try again later."
          );
        }
        // Iterate over the response data
        const promises = response?.data?.map(async (item) => {
          const prodId = item?.idproducthoreca; // Assuming 'idproducthoreca' is the identifier
          // Initialize totalCost and vat to default values
          let totalCost = 0;
          let vat = null;
          if (prodId) {
            // Get cost data for the product using prodId
            const productData = await getReservationTypeBasedOnProducts(
              key,
              prodId
            );
            // Calculate the total cost for this item using the guest counts
            totalCost =
              (productData?.price1 || 0) * parseInt(adult) +
              (productData?.price2 || 0) * parseInt(child) +
              (productData?.price3 || 0) * parseInt(kid) +
              (productData?.price4 || 0) * parseInt(baby) +
              (productData?.price5 || 0) * parseInt(toddler);
            vat = productData?.vat;
          }
          // Return the item with the total cost added
          return {
            ...item, // Copy the original item fields
            totalCost, // Add the calculated total cost
            vat,
          };
        });
        // Wait for all promises to complete
        const updatedResponse = await Promise.all(promises);
        // Dispatch the updated response with the total costs
        dispatch(setReservationTypeDatas(updatedResponse));
      } catch (error) {
        console.error("Error fetching reservation type:", error?.message);
      } finally {
        setReserveTypeLoading(false); // Stop loading after success or error
      }
    };
  
    const fetchWidgetSettingsDetails = async (lang) => {
      try {
        setWidgetLoading(true);
        const response = await FetchWidgetConfigDetails(key ,widgetSetupId, lang,guestId);
        if (response?.status != 200 || !response?.data) {
          throw new Error(
            "Failed to fetch widget settings details. Please try again later."
          );
        }
        const result = response?.data?.basicLanguages?.reduce((acc, item) => {
          const tag = item.tag.replace(/{|}/g, "").replace(/\s+/g, "");
          const data = item.widgetTranslateLanguages[0]?.name;
          acc[tag] = data; // Assign data to the key acc[tag]
          return acc;
        }, {});
        dispatch(updateWidgetConfig(response?.data));
        dispatch(updateButtonText(response?.data?.fields?.reservationButtonText));
        dispatch(setLanguageWords(result));
      
        setWidgetLoading(false);
      } catch (error) {
        console.error("Error fetching widget settings details:", error);
        setWidgetLoading(false);
      }
    };
  
    const fetchGuestDetailsByToken=async()=>{
      try {
        const response=await GetGuestDetailsByKey(widgetConfig?.token,key,guestId)
        if(!response){
          throw new Error("Failed to fetch guest details. Please try again later.")
        }
        dispatch(updateGuestInfo(response))
      } catch (error) {
        console.error("Error fetching guest details by token:", error);  
      }
    }
      const handleClose = () => {
    setOpenWidget(false);
  };
  
    useEffect(()=>{
      if(widgetConfig?.token){
        fetchGuestDetailsByToken()
      }
    },[widgetConfig])

    useEffect(() => {
      if (!languageLoaded && !isBackToHoreca) {
        fetchLanguageDetails();
      }
    }, [languageLoaded, isBackToHoreca]);
  
    useEffect(() => {
      if (defaultLanguage && defaultLanguage.trim() !== "" && !isBackToHoreca) {
        fetchWidgetSettings(defaultLanguage);
      }
    }, [defaultLanguage, isBackToHoreca]);
  
    useEffect(() => {
      if (defaultLanguage && defaultLanguage.trim() !== "") {
        // Checks if defaultLanguage is a non-empty string
        fetchWidgetSettingsDetails(defaultLanguage);
      }
    }, [defaultLanguage]);
  
    useEffect(() => {
      if (defaultLanguage?.trim() != "" && !isBackToHoreca)
        fetchWidgetTitleandInfo(widgetSetupId, defaultLanguage);
    }, [defaultLanguage, isBackToHoreca]);
  
    useEffect(() => {
      if (
        WidgetSetting?.length > 0 &&
        totalCount > 0 &&
        !isAddGuest &&
        !isBackToHoreca
      ) {
        getUnavailableCalenderDetails();
      }
    }, [WidgetSetting, totalCount, isAddGuest, isBackToHoreca]);
  
   
  
    useEffect(() => {
      if (!isBackToHoreca) {
        fetchReservationType();
      }
    }, 
    [
      totalCount,
      adult,
      child,
      kid,
      toddler,
      defaultLanguage,
      selectedDate,
      isBackToHoreca,
    ]
    );
  
    useEffect(() => {
      document.body.setAttribute("style", "background-color: transparant;");
      const resReqMin = WidgetSetting?.find(
        (item) => item?.tag == "reservationRequest"
      )?.data;
      setResReqMin(resReqMin == null ? "22" : resReqMin);
    }, [WidgetSetting]);
  
    function calculateEndTime(startTime, secondsToAdd) {
      return dayjs(`1970-01-01 ${startTime}`)
        .add(secondsToAdd, "second")
        .format("HH:mm:ss");
    }
  
    const fetchCombinations = async () => {
      setCombinationLoading(true)
      dispatch(setCombinationList([]));
      const endTime = calculateEndTime(time, reservType?.duration);
      const parsedDate = dayjs(selectedDate, "DD-MM-YYYY", true);
      // Check if date is valid
      if (!parsedDate?.isValid()) {
        return;
      }
      // Format the valid date into 'YYYY-MM-DD'
      const formattedDate = parsedDate.format("YYYY-MM-DD");
      const payload = {
        key: key,
        idreservationtype: parseInt(reservType?.idreservationtype),
        ArrivalDate: formattedDate,
        ArrivalTime: time,
        DepatureTime: endTime,
        Field1: parseInt(adult),
        Field2: parseInt(child),
        Field3: parseInt(kid),
        Field4: parseInt(toddler),
        Field5: parseInt(baby),
        LanguageCode: defaultLanguage,
        NoOfGuest: parseInt(totalCount),
      };
      try {
        const response = await getCombinationList(payload);
        dispatch(setCombinationList(response));
        setCombinationLoading(false)
      } catch (error) {
        console.error(error);
        setCombinationLoading(false)
      }
    };
    const fetchReservationGroupDetails = async () => {
        const parsedDate = dayjs(selectedDate, "DD-MM-YYYY");
        const formattedDate = parsedDate.format("YYYY-MM-DD");
        const [hours, minutes, seconds] = time.split(":");
        const date = new Date();
        date.setHours(hours, minutes, seconds, 0); // Set hours, minutes, and seconds
        const formattedTime = date.toTimeString().slice(0, 8); // Extracts HH:mm:ss
        const payload = {
          idreservationtype: parseInt(reservType.idreservationtype) ?? 0,
          date: "2024-11-10",
          key: key,
          time: formattedTime,
          lang: defaultLanguage,
        };
        try {
          const response = await getReservationGroup(payload);
          if (response?.status != 200 || !response?.data) {
            throw new Error("Couldn't get reservation group");
          }
          dispatch(setReservationGroupDatas(response?.data));
        } catch (error) {
          console.error("error fetching reservation group : ", error?.message);
        }
      };
    useEffect(() => {
      if (time) fetchCombinations();
    }, [time]);
  
    const send = (
      frameHeight,
      frameWidth,
      top,
      right,
      bottom,
      left,
      floating,
      redirectUrl
    ) => {
      window.parent.postMessage(
        {
          reservationIframeHeight: frameHeight,
          reservationIframeWidth: frameWidth,
          reservationIframePositionTop: top,
          reservationIframePositionRight: right,
          reservationIframePositionBottom: bottom,
          reservationIframePositionLeft: left,
          reservationIframePositionFloating: floating,
          redirectUrl: redirectUrl,
        },
        "*"
      );
    };
    useEffect(() => {
      dispatch(updateTotalCount(adult));
    }, [adult]);
    useEffect(() => {
      if (adult > 10) {
        dispatch(
          checkGuestLimit({
            guestType: "adult",
            isGreaterThan10: true,
          })
        );
      } else {
        dispatch(
          checkGuestLimit({
            guestType: "adult",
            isGreaterThan10: false,
          })
        );
      }
    }, [adult]);
  
   
  
    useEffect(() => {
      if (Object.keys(reservType).length > 0 && time && !isBackToHoreca) {
        fetchReservationGroupDetails(); // Fetch reservation group details when reservation type, selected date and time are available
      }
    }, [reservType, time, isBackToHoreca, defaultLanguage]);
    useEffect(() => {
      if (
        reservationGroupData?.length == 1 ||
        !widgetConfig?.settings?.showReservationGroup
      ) {
        dispatch(updateReservationGroup(reservationGroupData[0])); // Update reservation group details when reservation group data is available
      }
    }, [reservationGroupData]);

    return{
        totalCount,
        selectedDate,
        reservType,
        time,
        adult,
        child,
        kid,
        baby,
        toddler,
        reservationGroupData,
        isBackToHoreca,
        defaultLanguage,
        isOpenWidget,

        WidgetSetting,
        key,
        widgetConfig,
        languageLoaded,
        guestId,
        resType,
        theme,
        widgetLoading,
        setWidgetLoading,
        send,
        handleClose,
        openWidget,
        setOpenWidget,
        widgetSetupId,
        dispatch,
        buttonText,
        getWidgetPositionStyle,
        combinationLoading
        
        

    }
}

export default useHorecaWidget
